import { List, ListItemText, Tooltip } from 'appkit-react';

export const columnsConfig = (history, deleteUser) => {
    const columns = [
        {
            Header: 'ID',
            accessor: 'userId',
            minWidth: 50,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'User name',
            accessor: 'fullName',
            minWidth: 150,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Organization',
            accessor: 'userTenants',
            minWidth: 290,
            resizable: true,
            sortable: true,
            Cell: ({ original }) => {
                let names = '';
                if (original.userTenants && original.userTenants.length > 0) {
                    original.userTenants.forEach(element => {
                        names += `${element.name}, `;
                    });
                }
                names = names.trim();
                names = names.slice(0, names.length - 1);
                return names;
            },
        },
        {
            Header: 'Email ID',
            accessor: 'email',
            minWidth: 250,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'User status',
            accessor: 'iamUserStatus',
            minWidth: 100,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Actions',
            accessor: 'action',
            minWidth: 60,
            resizable: true,
            sortable: true,
            Cell: ({ original }) => {
                const { registrationStatus } = original;
                return (
                    <div className="menu-icon">
                        <Tooltip
                            content={
                                registrationStatus === 'REGISTERED' ? (
                                    <List>
                                        <ListItemText onClick={() => {
                                            history.push(
                                                {
                                                    pathname: '/user',
                                                    state: {
                                                        userId: original.userId,
                                                    },
                                                },
                                            );
                                        }}
                                        >
                                            Edit
                                        </ListItemText>
                                        <ListItemText onClick={() => deleteUser(original)}>
                                            Delete
                                        </ListItemText>
                                    </List>
                                ) : (
                                    <ListItemText>
                                        Cannot do any operations. User is not registered with us.
                                    </ListItemText>
                                )
                            }
                            trigger="click"
                            refClassName="a-account-info"
                            className="a-account-options"
                            clickToClose
                            tooltipTheme="light"
                            style={{ zIndex: 100, width: '150px' }}
                        >
                            <span className="appkiticon icon-vertical-more-fill a-font-16 a-text-orange" aria-hidden="true" style={{ cursor: 'pointer' }} />
                        </Tooltip>
                    </div>
                );
            }
            ,
        },
    ];
    return columns;
};

export const listItems = [
    [
        <i key={1} className="appkiticon icon-person-outline icon" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: 'white', fontSize: '0.7rem' }}>User</span>,
    ],
    [
        <i key={1} className="appkiticon icon-management-outline icon" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Tenant</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline icon" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Intake</span>,
    ],
];
